import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/stock/${dossierId}/DossierRatingComponent`, method: 'DELETE', token: token })
}
